import * as Sentry from '@sentry/react';

/**
 * Console error monitoring (ARCHITECTURE.md §8).
 *
 * Scrubbing matters more here than in a typical dashboard: the console renders
 * the consent ledger and the identity graph, so a breadcrumb capturing a fetch
 * URL or a form field could carry a person id off-platform. Everything that
 * could hold one is stripped or disabled.
 */
export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE,
    release: import.meta.env.VITE_GIT_SHA,
    sendDefaultPii: false,

    integrations: [
      Sentry.breadcrumbsIntegration({
        // Console output and fetch URLs are the two places a person id would
        // realistically leak into an event.
        console: false,
        fetch: false,
        xhr: false,
      }),
    ],

    beforeBreadcrumb(breadcrumb) {
      // Navigation breadcrumbs carry route params; campaign ids are fine, but
      // the rule is simpler to keep if URLs never travel at all.
      if (breadcrumb.category === 'navigation') return null;
      return breadcrumb;
    },

    beforeSend(event) {
      if (event.request) {
        delete event.request.query_string;
        delete event.request.data;
        delete event.request.headers;
      }
      return event;
    },
  });
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;
